import React, { useEffect, useState } from 'react'

const LEFT_IMAGES = [
    '/img/overlays/messages/message-dorados-interaktia-blanco.png'
];

const RIGHT_IMAGES = [
    '/img/overlays/messages/message-dorados-interaktia-blanco.png',
    // '/img/overlays/messages/message-adsl-interaktia-amistad-2.png',
    // '/img/overlays/messages/message-adsl-interaktia-amistad-3.png'
];


const Messages = ({ data }) => {
    const [verticalOffset, setVerticalOffset] = useState(0);
    const [flowState, setFlowState] = useState('idle'); // idle, entering, typing, visible, fadingOut
    const [messageData, setMessageData] = useState(null);
    const [pendingData, setPendingData] = useState(null);
    const [displayedText, setDisplayedText] = useState('');

    const [leftImage, setLeftImage] = useState(LEFT_IMAGES[0]);
    const [rightImage, setRightImage] = useState(RIGHT_IMAGES[0]);
    const [imageIndex, setImageIndex] = useState(0);

    // Actualizar imágenes dinámicas cuando cambia messageData
    useEffect(() => {
        if (messageData) {
            setImageIndex(prevIndex => {
                let nextIndex;
                if (messageData.design && messageData.design > 0) {
                    nextIndex = (messageData.design - 1);
                } else {
                    nextIndex = prevIndex + 1;
                }
                setLeftImage(LEFT_IMAGES[nextIndex % LEFT_IMAGES.length]);
                setRightImage(RIGHT_IMAGES[nextIndex % RIGHT_IMAGES.length]);
                return nextIndex;
            });
        }
    }, [messageData]);

    const flowStateRef = React.useRef(flowState);
    useEffect(() => {
        flowStateRef.current = flowState;
    }, [flowState]);

    // 1. Recepción y encolamiento de datos
    useEffect(() => {
        // Si no hay datos, no hacemos nada
        if (!data) return;

        // A. Configuración (Posición)
        if (data.type === 'config' && data.offsetY !== undefined) {
            setVerticalOffset(data.offsetY);
            return;
        }

        // B. Comando de Ocultar / Quitar
        // Si mandan a limpiar o llega tu payload de quitar (ej. {type: "messages", data: {idTile: 20}})
        if (!data.message) {
            setPendingData(null);
            if (flowStateRef.current !== 'idle' && flowStateRef.current !== 'fadingOut') {
                setFlowState('fadingOut');
            }
            return;
        }

        // C. Comando de Mostrar Mensaje Nuevo
        if (flowStateRef.current === 'idle') {
            setMessageData(data);
            setFlowState('entering');
        } else {
            setPendingData(data);
            if (flowStateRef.current !== 'fadingOut') {
                setFlowState('fadingOut');
            }
        }

    }, [data]);

    // 2. Control de transiciones (Entrada y Salida)
    useEffect(() => {
        let timeout;
        if (flowState === 'entering') {
            // El tiempo debe coincidir con la duración de la animación CSS de entrada
            timeout = setTimeout(() => setFlowState('typing'), 500); // <--- Efecto de entrada y salida. Coincide con 0.5s de SASS. Cambiar SASS si es que se cambia este valor.
        } else if (flowState === 'fadingOut') {
            // El tiempo debe coincidir con la duración de la animación CSS de salida
            timeout = setTimeout(() => {
                if (pendingData) {
                    setMessageData(pendingData);
                    setPendingData(null);
                    setFlowState('entering');
                } else {
                    setMessageData(null);
                    setFlowState('idle');
                }
                setDisplayedText('');
            }, 500); // <--- Efecto de entrada y salida. Coincide con 0.5s de SASS. Cambiar SASS si es que se cambia este valor.
        }
        return () => clearTimeout(timeout);
    }, [flowState, pendingData]);

    // 3. Efecto Máquina de Escribir
    useEffect(() => {
        if (flowState === 'typing' && messageData) {
            let currentIndex = 0;
            const fullText = messageData.message;
            setDisplayedText('');
            
            const interval = setInterval(() => {
                setDisplayedText(fullText.substring(0, currentIndex + 1));
                currentIndex++;
                
                if (currentIndex >= fullText.length) {
                    clearInterval(interval);
                    setFlowState('visible');
                }
            }, 35); // Velocidad de la máquina de escribir (ms por letra)
            // Menor = más rápido (ej. 20). Mayor = más lento (ej. 60).
            
            return () => clearInterval(interval);
        }
    }, [flowState, messageData]);

    if (flowState === 'idle') return null;

    return (
        <div className="messages" style={{ bottom: `${verticalOffset}px` }}>
            <div className={`messages__banner messages__banner--${flowState}`}>
                {/* <img src='/img/selfiefan/luchoFest/confeti-messages.png' className='messages__confeti--Left' /> */}
                {/* <img src='/img/selfiefan/luchoFest/banderin-messages.png' className='messages__banderines--Left' /> */}
                {/* <img className="messages__logo messages__logo--left" src="/img/selfiefan/luchoFest/lucho-face-messages.png" alt="Logo Izquierdo" /> */}
                {/* <img className="messages__logo messages__logo--left" src="/img/overlays/messages/joao-pedro.png" alt="Logo Izquierdo" /> Logo ADSL /img/favicon/big.png */}
                <img className="messages__logo messages__logo--left" src={leftImage} alt="Logo Izquierdo" /> {/* Logo ADSL /img/favicon/big.png */}
                
                <div className="messages__content">
                    {messageData?.sender && (
                        <div className="messages__sender">De: {messageData.sender}</div>
                    )}
                    <div className="messages__text">{displayedText}</div>
                </div>

                {/* <img src='/img/selfiefan/luchoFest/confeti-messages.png' className='messages__confeti--Right' /> */}
                {/* <img src='/img/selfiefan/luchoFest/banderin-messages.png' className='messages__banderines--Right' /> */}
                {/* <img className="messages__logo messages__logo--right" src="/img/selfiefan/luchoFest/cake-messages.png" alt="Logo Derecho" /> */}
                {/* <img className="messages__logo messages__logo--right" src="/img/overlays/messages/message-adsl-logo-five.png" alt="Logo Derecho" /> */}
                {/* <img className="messages__logo messages__logo--right" src="/img/overlays/messages/message-barrio9-five.png" alt="Logo Derecho" /> */}
                <img className="messages__logo messages__logo--right" src={rightImage} alt="Logo Derecho" />
            </div>
        </div>
    );
};

export { Messages };